<div *ngIf="toggled && mobileView" style="padding-left:20px; padding-right:20px;">
	<div class="jmObjectWidgetCover row" style="max-height:55px; min-height:0">
		<div class="col-2"><img appImgCheck [defaultImage]="objectIconDefault" [src]="objectIcon" class="jmCollapsedProfilePicture" /></div>
		<div class="col-8">
			<div class="jmPageTitle" style="line-height: 55px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{objectName}}</div>
		</div>
		<div class="col-2">
			<div class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square" (click)="toggled = false" style="position:absolute; margin-top:15px; right:0px; font-size: 20px;" role="button"></div>
		</div>
	</div>
</div>
<div *ngIf="!toggled" style="padding:0px; height:100%">
	<!--Cover image-->
	<div class="jmObjectWidgetCover" style="height: 64%">
		<img appImgCheck [defaultImage]="coverImageDefault" [src]="coverImg" style="width:100%;height:auto;" />
	</div>

	<!-- Layout for desktop views -->
	<div *ngIf="!mobileView">
		<!--profile image-->
		<div class="jmButtonAlignment w-100" style="bottom:18%;">
			<table style="table-layout:fixed;width:100%;">
				<tr>
					<td style="width:42%; padding: 20px 0px 0px 20px; white-space:nowrap; padding-right:20px;">
						<div style="display:inline-block; max-width:95%;">
							<div class="jmPageTitle" style="white-space:nowrap; text-overflow: ellipsis; overflow: hidden;">{{objectName}} </div>
						</div>
						<span class="jmInfoIcon"><i class="jmInfoCircle" (click)="displayInfoWrapper()"></i></span>
					</td>
					<td style="width:15%;">
						<div class="text-center w-100">
							<img appImgCheck [defaultImage]="objectIconDefault" [src]="objectIcon" class="jmProfilePictureBtn" style="width:100%;" />
						</div>
					</td>
					<td style="padding: 20px 20px 0px 0px;">
						<div class="text-end">
							<span style="padding: 15px">
								<app-social-follow-icon [source]="source" [objectId]="objectId" (onToggled)="socialToggled($event)"></app-social-follow-icon>
							</span>
						</div>
					</td>
				</tr>
			</table>
		</div>
		<div class="jmProfileWidgetBottomRow">
			<div class="row" style="vertical-align:middle">
				<div class="col-4"></div>
				<div class="col-4 jmVerticalDividerLeftRight text-center text-info" (click)="openNewFeatureModal()" role="button">
					<span class="jmStandOutText">{{followers}}</span><br />
					<span class="jmSupportText">FOLLOWERS</span>
				</div>
				<div class="col-4"></div>
			</div>
		</div>
	</div>

	<!-- Mobile view" -->
	<div *ngIf="mobileView" class="jmImgIconWidgetPositionMobile">
		<!-- Image row -->
		<div class="row">
			<div class="offset-4 col-4">
				<img appImgCheck [defaultImage]="objectIconDefault" [src]="objectIcon" class="jmProfilePictureBtn text-center" style="width:100%;" />
			</div>
		</div>
		<!-- Social Media icons row -->
		<div class="row">
			<div class="offset-3 col-6 text-center">
				<span style="padding: 5px">
					<app-social-follow-icon [source]="source" [objectId]="objectId" (onToggled)="socialToggled($event)"></app-social-follow-icon>
				</span>
			</div>
		</div>
		<!-- Title row -->
		<div class="row">
			<div class="col-6 offset-3 text-center">
				<span class="jmPageTitle">{{objectName}}<span class="jmInfoIcon"  (click)="displayInfoWrapper()" role="button"><i class="jmInfoCircle"></i></span></span>
			</div>
		</div>
		<br />
		<!-- Followers row -->
		<div class="row">
			<div class="col-4"></div>
			<div class="col-4 text-center text-info" (click)="openNewFeatureModal()" role="button">
				<span class="jmStandOutText">{{followers}}</span><br />
				<div class="jmSupportText">FOLLOWERS</div>
			</div>
			<div class="col-4"></div>
		</div>
	</div>
</div>
